import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import * as setSnackBarActions from '@store/snack-bar/snack-bar.actions';

@Component({
  selector: 'app-snack-bar',
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss'],
})
export class SnackBarComponent implements OnChanges, OnDestroy {
  @Input() snackBarSuccessInput: boolean = false;
  @Input() showSnackBarInput: boolean = false;
  @Input() snackBarMessageInput: string = '';
  @Output() showSnackBarOutput: EventEmitter<boolean> = new EventEmitter<boolean>();
  public snackBarSuccess: boolean = false;
  public showSnackBar: boolean = false;
  public snackBarMessage: string = '';
  private unsubscribeAll$: Subject<void> = new Subject();

  constructor(private store: Store) {}

  ngOnChanges(changes: SimpleChanges) {
    this.snackBarSuccess = changes?.snackBarSuccessInput?.currentValue;
    this.showSnackBar = changes?.showSnackBarInput?.currentValue;
    this.snackBarMessage = changes?.snackBarMessageInput?.currentValue;

    if (this.showSnackBar) {
      setTimeout(() => {
        this.closeSnackBar();
      }, 5000);
    }
  }

  closeSnackBar() {
    this.showSnackBarOutput.emit(false);
    this.store.dispatch(setSnackBarActions.setSnackBar({ snackBarSuccess: false, showSnackBar: false, snackBarMessage: '' }));
  }

  ngOnDestroy(): void {
    this.unsubscribeAll$.next();
    this.unsubscribeAll$.complete();
  }
}
